module.exports = __webpack_public_path__ + "media/customer_tickets/alert-eb7d6fb9.svg";